import { createContext } from 'react';

import type { AnalyticsClient } from '../analytics-client';

/**
 * Internal context shared between `AnalyticsProvider` (publishes) and
 * `useAnalytics` (subscribes). Lives in `internal/` so consumers can't
 * import it directly — the only supported way to read the client is via
 * `useAnalytics()`, which guarantees the `null`-during-SSR contract.
 */
export const AnalyticsContext = createContext<AnalyticsClient | null>(null);
